<template>
  <div class="l-page l-page--analysis-all">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main--flex">
      <div class="l-main-head">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" :additional-classes="['p-breadcrumb--analysis-all']" />
        <!-- /パンくずリスト -->
        <div
          class="c-select-calendar u-w370"
          @click="onPeriodClick"
        >
          <div class="c-select-calendar__selected">
            <div class="c-icon c-icon--gray-3 u-wh18">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <use xlink:href="/assets/img/sprite.svg#calendar" />
              </svg>
            </div>
            <div class="c-select-calendar__date">
              {{ formattedFrom }}
            </div>
            <div class="c-select-calendar__date">
              {{ formattedTo }}
            </div>
          </div>
          <div class="c-error c-error--balloon c-error--group-name">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-analysis-all-summary">
          <div class="c-title">
            <div class="c-title__text u-fs34">配信成果</div>
            <div class="c-date u-w620">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ formattedFrom }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ formattedTo }}</li>
              </ul>
            </div>
          </div>
          <div class="p-analysis-all-summary__metrics">
            <div class="p-metrics-summary">
              <ul class="p-metrics-summary-list">
                <li class="p-metrics-summary-list__item is-loading">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--impression is-active">
                    <dt class="c-metrics__label">インプレッション</dt>
                    <dd class="c-metrics__value">-</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">-</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item is-loading">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--click">
                    <dt class="c-metrics__label">クリック数</dt>
                    <dd class="c-metrics__value">-</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">-</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item is-loading">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--ctr">
                    <dt class="c-metrics__label">クリック率(%)</dt>
                    <dd class="c-metrics__value">-</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">-</p>
                    </dd>
                  </dl>
                </li>
              </ul>
            </div>
          </div>
          <div class="p-analysis-all-summary__data is-loading">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <svg class="c-graph-line c-graph-line--summary">
              <defs>
                <clipPath id="clipPath">
                  <rect
                    x="15"
                    y="0"
                    height="330"
                    width="930"
                  />
                </clipPath>
              </defs>
              <g class="c-graph-line-frame" clip-path="url(#clipPath)">
                <rect
                  class="c-graph-line-frame__rect"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
                <line
                  class="c-graph-line-frame__line"
                  x1="15"
                  x2="945"
                  y1="330"
                  y2="330"
                />
              </g>
              <g class="c-graph-line-bg" clip-path="url(#clipPath)">
                <g class="c-graph-line-bg__x" />
                <g class="c-graph-line-bg__y" />
              </g>
              <g class="c-graph-line-chart" clip-path="url(#clipPath)" />
              <g class="c-graph-line-pointer" clip-path="url(#clipPath)">
                <rect
                  class="c-graph-line-pointer__area"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
              </g>
              <g class="c-graph-line-axis">
                <g class="c-graph-line-axis__x" />
                <g class="c-graph-line-axis__y--left" />
                <g class="c-graph-line-axis__y--right" />
              </g>
              <g class="c-graph-line-label" />
            </svg>
            <div class="c-tooltip c-tooltip--graph-line c-tooltip--summary">
              <div class="c-tooltip__title">-</div>
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--optin">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--delivery">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--impression">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--click">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--ctr is-active">-</li>
              </ul>
            </div>
          </div>
          <div class="p-analysis-all-summary__data-table is-loading">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--summary-group">
              <thead>
                <tr>
                  <th class="c-table__cell--center is-sortable"><span
                    class="c-table__text"
                  >グループ名</span><span
                    class="c-btn c-btn--sort"
                    data-type="group"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >配信対象数</span><span
                    class="c-btn c-btn--sort c-btn--sort-desc"
                    data-type="delivery"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >インプレッション</span><span
                    class="c-btn c-btn--sort"
                    data-type="impression"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >クリック数</span><span
                    class="c-btn c-btn--sort"
                    data-type="click"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >クリック率(%)</span><span
                    class="c-btn c-btn--sort"
                    data-type="ctr"
                  ></span></th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-analysis-all-summary-optin">
          <div class="c-title">
            <div class="c-title__text u-fs34">オプトイン数推移</div>
            <div class="c-date u-w440">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ formattedFrom }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ formattedTo }}</li>
              </ul>
            </div>
            <div class="c-text">
              <a :href="optinCsvUrl">CSVデータ ダウンロード</a>
            </div>
          </div>
          <div class="p-analysis-all-summary-optin__data is-loading">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <svg class="c-graph-line c-graph-line--summary-optin">
              <defs>
                <clipPath id="clipPathSummaryOptin">
                  <rect
                    x="15"
                    y="0"
                    height="330"
                    width="930"
                  />
                </clipPath>
              </defs>
              <g class="c-graph-line-frame" clip-path="url(#clipPathSummaryOptin)">
                <rect
                  class="c-graph-line-frame__rect"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
                <line
                  class="c-graph-line-frame__line"
                  x1="15"
                  x2="945"
                  y1="330"
                  y2="330"
                />
              </g>
              <g class="c-graph-line-bg" clip-path="url(#clipPathSummaryOptin)">
                <g class="c-graph-line-bg__x" />
                <g class="c-graph-line-bg__y" />
              </g>
              <g class="c-graph-line-chart" clip-path="url(#clipPathSummaryOptin)" />
              <g class="c-graph-line-pointer" clip-path="url(#clipPathSummaryOptin)">
                <rect
                  class="c-graph-line-pointer__area"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
              </g>
              <g class="c-graph-line-axis">
                <g class="c-graph-line-axis__x" />
                <g class="c-graph-line-axis__y--left" />
                <g class="c-graph-line-axis__y--right" />
              </g>
              <g class="c-graph-line-label" />
            </svg>
            <div class="c-tooltip c-tooltip--graph-line c-tooltip--summary-optin">
              <div class="c-tooltip__title">-</div>
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--optin">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--delivery">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--impression">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--click">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--ctr is-active">-</li>
                <!-- 設計書 §4.2: オプトイン推移グラフ tooltip にアクティブユーザー数を追加 -->
                <li class="c-tooltip-list__item c-tooltip-list__item--active-user">-</li>
              </ul>
            </div>

          </div>
          <div class="p-analysis-all-summary-optin__data-table is-loading">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--summary-optin-page">
              <thead>
                <tr>
                  <th class="c-table__cell--center is-sortable">
                    <span class="c-table__text">許可されたページ</span>
                    <span class="c-btn c-btn--sort" data-type="page"></span>
                  </th>
                  <th class="c-table__cell--center u-w320 is-sortable">
                    <span class="c-table__text">許可数</span>
                    <span class="c-btn c-btn--sort c-btn--sort-desc" data-type="grantedCount"></span>
                  </th>
                  <th class="c-table__cell--center u-w320 is-sortable">
                    <span class="c-table__text">許可率</span>
                    <span class="c-btn c-btn--sort c-btn--sort-desc" data-type="optinRate"></span>
                  </th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="l-main-content--half">
        <div class="p-analysis-all-timezone">
          <div class="c-title">
            <div class="c-title__text">曜日と時間での結果</div>
            <div class="c-text">
              <a :href="linkData.deliveryTimezoneUrl">詳細を見る</a>
            </div>
          </div>
          <div class="c-tab c-tab--analysis c-tab--timezone">
            <ul class="c-tab-list">
              <li class="c-tab-list__item is-active" data-type="delivery">配信対象</li>
              <li class="c-tab-list__item" data-type="impression">インプレッション</li>
              <li class="c-tab-list__item" data-type="click">クリック数</li>
              <li class="c-tab-list__item" data-type="ctr">クリック率</li>
            </ul>
          </div>
          <div class="p-analysis-all-timezone__data is-loading">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="c-graph-heatmap-timezone">
              <div class="c-graph-heatmap-timezone__row">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">月</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">火</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">水</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">木</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">金</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">土</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">日</div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="0_3">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  0〜3時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-0_3">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="3_6">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  3〜6時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-3_6">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="6_9">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  6〜9時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-6_9">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="9_12">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  9〜12時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-9_12">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="12_15">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  12〜15時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-12_15">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="15_18">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  15〜18時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-15_18">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="18_21">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  18〜21時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-18_21">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="21_0">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  21〜24時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-21_24">
                </div>
              </div>
            </div>
            <ul class="c-graph-heatmap-timezone-bar">
              <li class="c-graph-heatmap-timezone-bar__item"><span></span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r1">
                <span>-</span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r2">
                <span>-</span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r3">
                <span>-</span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r4">
                <span>-</span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r5">
                <span>-</span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r6">
                <span>-</span></li>
            </ul>
            <ul class="c-graph-heatmap-timezone-bar-label-x">
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="l-main-content--half">
        <div class="p-analysis-all-device">
          <div class="c-title">
            <div class="c-title__text">デバイス</div>
            <div class="c-text">
              <a :href="linkData.deliveryDeviceUrl">詳細を見る</a>
            </div>
          </div>
          <div class="c-tab c-tab--analysis c-tab--device">
            <ul class="c-tab-list">
              <li class="c-tab-list__item is-active" data-type="delivery">配信対象</li>
              <li class="c-tab-list__item" data-type="impression">インプレッション</li>
              <li class="c-tab-list__item" data-type="click">クリック数</li>
              <li class="c-tab-list__item" data-type="ctr">クリック率</li>
            </ul>
          </div>
          <div class="p-analysis-all-device__data is-loading">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <svg class="c-graph-donuts c-graph-donuts--device">
              <g class="c-graph-donuts__chart" />
              <g class="c-graph-donuts__values" />
              <g class="c-graph-donuts__title" />
              <g class="c-graph-donuts__labels" />
            </svg>
            <div class="c-tooltip c-tooltip--graph-donuts c-tooltip--device">
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--desktop is-active">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--mobile is-active">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--tablet is-active">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--other is-active">-</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content--half">
        <div class="p-analysis-all-demogra">
          <div class="c-title">
            <div class="c-title__text">デモグラフィック</div>
            <div class="c-text">
            </div>
          </div>
          <div class="p-analysis-all-demogra__data is-loading">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="c-graph-ratio-gender">
              <div class="c-graph-ratio-gender__label">性別（%）</div>
              <div class="c-graph-ratio-gender-bar">
                <div class="c-graph-ratio-gender-bar-inner">
                  <div class="c-graph-ratio-gender-bar__item c-graph-ratio-gender-bar__item--left"></div>
                  <div class="c-graph-ratio-gender-bar__item c-graph-ratio-gender-bar__item--right"></div>
                </div>
              </div>
              <div class="c-graph-ratio-gender-value">
                <div class="c-graph-ratio-gender-value__item c-graph-ratio-gender-value__item--left"></div>
                <div class="c-graph-ratio-gender-value__item c-graph-ratio-gender-value__item--right"></div>
              </div>
            </div>
            <div class="c-graph-heatmap-age">
              <div class="c-graph-heatmap-age-bar__label">年齢（歳）</div>
              <ul class="c-graph-heatmap-age-bar">
                <li class="c-graph-heatmap-age-bar__item" data-age-type="_19"></li>
                <li class="c-graph-heatmap-age-bar__item" data-age-type="20_29"></li>
                <li class="c-graph-heatmap-age-bar__item" data-age-type="30_39"></li>
                <li class="c-graph-heatmap-age-bar__item" data-age-type="40_49"></li>
                <li class="c-graph-heatmap-age-bar__item" data-age-type="50_59"></li>
                <li class="c-graph-heatmap-age-bar__item" data-age-type="60_"></li>
              </ul>
              <ul class="c-graph-heatmap-age-bar-label-x">
                <div class="c-graph-heatmap-age-bar-label-x__item">それ以下</div>
                <div class="c-graph-heatmap-age-bar-label-x__item">20</div>
                <div class="c-graph-heatmap-age-bar-label-x__item">30</div>
                <div class="c-graph-heatmap-age-bar-label-x__item">40</div>
                <div class="c-graph-heatmap-age-bar-label-x__item">50</div>
                <div class="c-graph-heatmap-age-bar-label-x__item">それ以上</div>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content--half">
        <div class="p-analysis-all-interest">
          <div class="c-title">
            <div class="c-title__text">興味カテゴリ</div>
            <div class="c-text">
            </div>
          </div>
          <div class="p-analysis-all-interest__data is-loading">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <svg class="c-graph-treemap" xmlns="http://www.w3.org/2000/svg" />
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-analysis-all-prefecture">
          <div class="p-analysis-all-prefecture__header">
            <div class="c-title">
              <div v-if="activeRegionType == 'region'" class="c-title__text">配信先の地域</div>
              <div v-else class="c-title__text">配信先の都道府県（上位10件）</div>
              <div class="c-text"></div>
            </div>
            <prefecture-tab
              classes="c-tab--analysis"
              :current="activeRegionType"
              :on-select="onClickPrefectureTab"
            />
          </div>
          <div
            class="p-analysis-all-prefecture__data"
            :class="[{'is-loading': isLoadingHeatmapPrefecture}]"
          >
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div
              class="p-analysis-all-prefecture__item"
              :class="[{'is-active': activeRegionType == 'region'}]"
            >
              <heatmap-region
                ref="heatmapRegion"
                size="m"
              />
              <table-region
                ref="tableRegion"
                classes="c-table--heatmap-prefecture"
              />
            </div>
            <div
              class="p-analysis-all-prefecture__item"
              :class="[{'is-active': activeRegionType == 'prefecture'}]"
            >
              <heatmap-prefecture
                ref="heatmapPrefecture"
                size="m"
              />
              <table-prefecture
                ref="tablePrefecture"
                classes="c-table--heatmap-prefecture"
              />
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- モーダル: 表示期間の選択 -->
    <calendar-modal
      ref="refCalendarModal"
      :is-active=isActiveCalendarModal
      cancel-button-label="キャンセル"
      enter-button-label="決定"
      :dates="params"
      :on-close-click="onCloseCalendarModal"
      :on-cancel-click="onCancelCalendarModal"
      :on-enter-click="onEnterCalendarModal"
    />
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

export default {
  props: {
    breadcrumbData: Array,
    linkData: Object,
    displayPeriod: Object
  },
  data () {
    return {
      activeRegionType: 'region',
      errorMessage: '',
      updateAnalysis: null,
      heatmapPrefectureModule: null,
      heatmapRegionModule: null,
      isActiveCalendarModal: false,
      isError: false,
      isLoadingHeatmapPrefecture: true,
      params: {
        from: dayjs(this.displayPeriod.from).format(),
        to: dayjs(this.displayPeriod.to).format(),
        // カレンダーで選択できる日付範囲: 1年前 ~ 現在時間
        minDate: dayjs(this.displayPeriod.from).subtract(10, 'year').format(),
        maxDate: dayjs().format(),
      },
    }
  },
  computed: {
    formattedFrom: function() {
      return this.formatDate(this.params.from);
    },
    formattedTo: function() {
      return this.formatDate(this.params.to);
    },
    optinCsvUrl: function() {
      let url = '/api/analysis/summary-optin/csv?' +
        'from=' + dayjs(this.params.from).format('YYYY-MM-DD') +
        '&to=' + dayjs(this.params.to).format('YYYY-MM-DD');
      return url;
    },
  },
  mounted: function() {
    (this);
    const period = this.displayPeriod;
    import('../../funcs/pages/analysis').then(module => {
      this.updateAnalysis = module.Analysis();
      this.updateAnalysis(period);
    });

    this.updateDatasetForPrefectureHeatmap()
  },
  methods: {
    formatDate: function(dt) {
      return dayjs(dt).format('YYYY/MM/DD');
    },
    changePeriod: function(_date) {
      const period = {from: this.formattedFrom, to: this.formattedTo};
      this.updateAnalysis(period);
    },
    onPeriodClick: function() {
      this.isActiveCalendarModal = true;
      this.$refs.refCalendarModal.resetParams(this.params);
    },
    updateDatasetForPrefectureHeatmap() {
      // ローダー表示設定
      this.isLoadingHeatmapPrefecture = true

      // データ取得期間設定
      const period = {
        from: dayjs(this.params.from).format('YYYY-MM-DD'),
        to: dayjs(this.params.to).format('YYYY-MM-DD'),
      }

      // データ取得実行
      axios.get('/api/analysis/summary-prefecture/delivery/?from=' + period.from + '&to=' + period.to)
        .then(res => {
          // レスポンスデータの内容がイレギュラーな場合は処理終了
          if (!res.data || !res.data.items) throw new Error('Invalid response data.');

          // 地域別ヒートマップ、ランキングテーブルを更新
          this.$refs.heatmapRegion.init(res.data, 'delivery', period)
          this.$refs.tableRegion.init(res.data, period, {
            key: 'delivery',
            type: 'desc'
          }
          )

          // 都道府県別ヒートマップ、ランキングテーブルを更新
          this.$refs.heatmapPrefecture.init(res.data, 'delivery', period)
          this.$refs.tablePrefecture.init(res.data, period, {
            key: 'delivery',
            type: 'desc'
          }
          )

          // ローダー非表示設定
          setTimeout(() => { this.isLoadingHeatmapPrefecture = false }, 300)
        })
        .catch(_e => {
          // エラーモーダル表示
          this.isError = true;
          this.errorMessage = '配信先地域データの取得に失敗しました';
          // ローダー非表示設定
          setTimeout(() => { this.isLoadingHeatmapPrefecture = false }, 300)
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: カレンダーモーダルを閉じる処理
    onCloseCalendarModal: function() {
      this.isActiveCalendarModal = false
      // this.errorMessage = ''
    },
    // クリック: カレンダーモーダルを閉じる処理
    onChangeCalendarModal: function() {
      this.isActiveCalendarModal = false
      // this.errorMessage = ''
    },
    // クリック: カレンダーモーダルを閉じる処理
    onCancelCalendarModal: function() {
      this.isActiveCalendarModal = false
      // this.errorMessage = ''
    },
    // クリック: カレンダーモーダルを閉じる処理
    onEnterCalendarModal: function(from, to) {
      // 操作用モーダルのボタンローダーを表示
      this.isActiveCalendarModal = false
      this.params = {
        from: dayjs(from).format('YYYY-MM-DD'),
        to: dayjs(to).format('YYYY-MM-DD')
      }
      this.updateAnalysis(this.params);

      // 配信先ヒートマップ更新
      this.updateDatasetForPrefectureHeatmap();
      //
      // @TODO 他のグラフをコンポーネント化したら、ここに追記
      //
    },
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    // クリック: 都道府県タブをクリックした時
    onClickPrefectureTab: function(selected) {
      this.activeRegionType = selected
    }
  }
}
</script>
